import { Path, Svg } from '@react-pdf/renderer';

export function Emblem() {
  return (
    <Svg width={405} height={405} viewBox="0 0 405 405">
      <Path
        d="M202.5 0.5C90.6623 0.5 0 91.1623 0 203C0 314.838 90.6623 405.5 202.5 405.5H405V203C405 134.355 370.844 73.6878 318.6 37.0661V205.724C318.6 205.724 318.586 205.73 318.559 205.742C318.586 206.782 318.6 207.825 318.6 208.871C318.6 271.906 268.582 323.146 202.297 323.146C136.419 323.146 86.4001 271.906 86.4001 208.871C86.4001 145.43 136.419 94.5961 202.297 94.5961C225.058 94.5961 246.05 100.74 263.752 111.422V9.92891C244.429 3.80412 223.85 0.5 202.5 0.5ZM262.888 208.465C262.888 242.625 236.049 269.872 202.703 269.872C168.951 269.872 142.519 242.625 142.519 208.465C142.519 174.304 168.951 147.057 202.703 147.057C236.049 147.057 262.888 174.304 262.888 208.465Z"
        fill="#f4f2f4"
      />
    </Svg>
  );
}

export function Emblem40() {
  return (
    <Svg width={40} height={40} viewBox="0 0 40 40">
      <Path
        d="M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40H40V20C40 13.2203 36.6266 7.22843 31.4667 3.61147V20.269L31.4626 20.2708C31.4653 20.3735 31.4667 20.4765 31.4667 20.5799C31.4667 26.8055 26.5266 31.8663 19.9799 31.8663C13.4735 31.8663 8.53335 26.8055 8.53335 20.5799C8.53335 14.3141 13.4735 9.29344 19.9799 9.29344C22.228 9.29344 24.3013 9.90025 26.0496 10.9552V0.931252C24.1411 0.326333 22.1087 0 20 0ZM25.9643 20.5397C25.9643 23.9136 23.3135 26.6047 20.0201 26.6047C16.6865 26.6047 14.0759 23.9136 14.0759 20.5397C14.0759 17.1658 16.6865 14.4748 20.0201 14.4748C23.3135 14.4748 25.9643 17.1658 25.9643 20.5397Z"
        fill="#C8C7CB"
      />
    </Svg>
  );
}
